import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { buildCatNavProductsRequest } from "@faire/retailer-shared/categories/createRequests/buildCatNavProductsRequest";
import { createBrandFirstSearchRequest } from "@faire/retailer-shared/categories/createRequests/createBrandFirstSearchRequest";
import { recordPerformanceMark } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/recordPerformanceMark";
import { fetchBrandFirstResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/__internal__/fetchResults/__internal__/fetchBrandFirstResults";
import { fetchProductFirstResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/__internal__/fetchResults/__internal__/fetchProductFirstResults";
import { FILTERS_TIMING_FETCH_END_KEY, FILTERS_TIMING_FETCH_START_KEY } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/consts";
import { wrapAsyncFn } from "@faire/web--source/common/wrapAsyncFn";
export var fetchResults = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param, param1, strictLocalize) {
        var showProductFirstResults, navigationPath, filterKeys, requestPageSize, oneIndexedPageNumber, requestReferrer, signal;
        return _ts_generator(this, function(_state) {
            showProductFirstResults = param.showProductFirstResults, navigationPath = param.navigationPath, filterKeys = param.filterKeys, requestPageSize = param.requestPageSize, oneIndexedPageNumber = param.oneIndexedPageNumber, requestReferrer = param.requestReferrer, signal = param1.signal;
            if (showProductFirstResults) {
                return [
                    2,
                    fetchProductFirstResults(buildCatNavProductsRequest({
                        navigationPath: navigationPath,
                        filterKeys: filterKeys,
                        pageSize: requestPageSize,
                        pageNumber: oneIndexedPageNumber,
                        requestReferrer: requestReferrer
                    }), {
                        signal: signal
                    })
                ];
            }
            return [
                2,
                wrapAsyncFn(function() {
                    return fetchBrandFirstResults(createBrandFirstSearchRequest({
                        navigationPath: navigationPath,
                        filterKeys: filterKeys,
                        requestPageSize: requestPageSize,
                        oneIndexedPageNumber: oneIndexedPageNumber
                    }), {
                        signal: signal
                    }, strictLocalize);
                }, {
                    before: function() {
                        // TODO (marsohrabi): remove the performance mark after filter splitting is implemented
                        // on brand-first categories
                        recordPerformanceMark(FILTERS_TIMING_FETCH_START_KEY);
                    },
                    after: function() {
                        // TODO (marsohrabi): remove the performance mark after filter splitting is implemented
                        // on brand-first categories
                        recordPerformanceMark(FILTERS_TIMING_FETCH_END_KEY);
                    }
                })
            ];
        });
    });
    return function fetchResults(_, _1, strictLocalize) {
        return _ref.apply(this, arguments);
    };
}();
